/*
 * K-Beauty Real Gems — header behaviors (Phase 2).
 * - Mobile drawer open/close, two-screen slide (main <-> shop), tab switching
 *   and A–Z jump. Mirrors the prototype's interactions.
 * - Transparent-over-hero header on the homepage: toggles `.krg-header--solid`
 *   once the user scrolls past the first section.
 * - Cart-toggle hooks (`.js-cart-open`) are wired here as a no-op; Phase 3
 *   replaces this with the real AJAX cart drawer.
 */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  var nav = document.querySelector('[data-krg-mobile-nav]');
  var toggleBtn = document.querySelector('[data-krg-nav-toggle]');
  var body = document.body;

  function openNav() {
    if (!nav) return;
    nav.classList.add('krg-mobile-nav--open');
    nav.setAttribute('aria-hidden', 'false');
    if (toggleBtn) {
      toggleBtn.classList.add('krg-menu-toggle--open');
      toggleBtn.setAttribute('aria-expanded', 'true');
    }
    body.classList.add('krg-nav-open');
    // Force header solid while drawer is open so it never sits transparent over the drawer.
    forceHeaderSolid(true);
  }
  function closeNav() {
    if (!nav) return;
    nav.classList.remove('krg-mobile-nav--open');
    nav.classList.remove('krg-mobile-nav--shop');
    nav.setAttribute('aria-hidden', 'true');
    if (toggleBtn) {
      toggleBtn.classList.remove('krg-menu-toggle--open');
      toggleBtn.setAttribute('aria-expanded', 'false');
    }
    body.classList.remove('krg-nav-open');
    forceHeaderSolid(false);
  }
  function toggleNav() {
    if (!nav) return;
    if (nav.classList.contains('krg-mobile-nav--open')) closeNav();
    else openNav();
  }

  if (toggleBtn) toggleBtn.addEventListener('click', toggleNav);

  // Two-screen slide: deepen = show Shop tab screen; shallow = back to main
  document.querySelectorAll('[data-krg-mnav-deepen]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (nav) nav.classList.add('krg-mobile-nav--shop');
    });
  });
  document.querySelectorAll('[data-krg-mnav-shallow]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (nav) nav.classList.remove('krg-mobile-nav--shop');
    });
  });

  /* ---------- Tab switching inside Shop screen ---------- */
  document.querySelectorAll('[data-krg-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var key = tab.getAttribute('data-krg-tab');
      var wrap = tab.closest('.krg-tabwrap');
      if (!wrap) return;
      wrap.querySelectorAll('.krg-fd-tab').forEach(function (t) {
        t.classList.remove('krg-fd-tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('krg-fd-tab--active');
      tab.setAttribute('aria-selected', 'true');
      wrap.querySelectorAll('.krg-fd-panel').forEach(function (p) {
        p.classList.toggle('krg-fd-panel--active', p.getAttribute('data-krg-panel') === key);
      });
      var az = wrap.querySelector('.krg-az-index');
      if (az) az.classList.toggle('krg-az-index--show', key === 'brand');
    });
  });

  /* ---------- A–Z jump (Brand tab) ---------- */
  document.querySelectorAll('[data-krg-az]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var letter = btn.getAttribute('data-krg-az');
      var wrap = btn.closest('.krg-tabwrap');
      if (!wrap) return;
      var target = wrap.querySelector('[data-letter="' + letter + '"]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- Escape closes drawer ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  /* ---------- Transparent-on-hero scroll toggle ---------- */
  var header = document.querySelector('[data-krg-header]');
  var isTransparent = header && header.getAttribute('data-transparent') === 'true';
  var forcedSolid = false;

  function forceHeaderSolid(force) {
    forcedSolid = !!force;
    onScroll();
  }

  // Transparent only at the very top of the page; turns solid as soon as the
  // user starts scrolling. (Small threshold avoids flicker from sub-pixel jitter.)
  var SOLID_AFTER = 8;

  // IMPORTANT: on desktop (≥990px) Horizon sets html/body to `overflow:hidden`
  // and makes `.page-wrapper` the scroll container — the window never scrolls.
  // So we read scroll position from whichever is actually scrolling.
  var scroller = document.querySelector('.page-wrapper');

  function currentScroll() {
    return Math.max(
      window.scrollY || window.pageYOffset || 0,
      scroller ? scroller.scrollTop : 0
    );
  }

  function onScroll() {
    if (!header) return;
    if (!isTransparent) {
      header.classList.remove('krg-header--solid');
      return;
    }
    var solid = forcedSolid || currentScroll() > SOLID_AFTER;
    header.classList.toggle('krg-header--solid', solid);
  }

  if (isTransparent) {
    window.addEventListener('scroll', onScroll, { passive: true });
    if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', onScroll);
    onScroll();

    // Over the hero, opening the mega-menu turns the header solid so the white
    // dropdown panel reads against a white header rather than the image.
    document.querySelectorAll('[data-krg-megamenu]').forEach(function (wrap) {
      wrap.addEventListener('mouseenter', function () { forceHeaderSolid(true); });
      wrap.addEventListener('mouseleave', function () { forceHeaderSolid(false); });
      wrap.addEventListener('focusin', function () { forceHeaderSolid(true); });
      wrap.addEventListener('focusout', function () { forceHeaderSolid(false); });
    });
  }

  /* Cart-toggle handling lives in assets/krg-cart.js (Phase 3). */
})();
